import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';
import { DateTime } from 'luxon';
import { SMALL_SCALE } from '../../BSLAConstants';

const BSLAPetroleumContaminationLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        url: 'https://ca.dep.state.fl.us/arcgis/rest/services/OpenData/DWM_STCM/MapServer/1',
        visible: false,
        title: 'Petroleum Contamination (FDEP)',
        minScale: SMALL_SCALE,
        popupTemplate: {
            outFields: ['*'],
            title: 'Petroleum Contamination (FDEP)',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');
                const content = (
                    <React.Fragment>
                        <BSLAPopupItemComponent label="Facility Name" value={atts.FACILITY_NAME} />
                        <BSLAPopupItemComponent label="Facility ID" value={atts.FACILITY_ID} />
                        <BSLAPopupItemComponent label="Facility Type" value={atts.FACILITY_TYPE} />
                        <BSLAPopupItemComponent label="Facility Status" value={atts.FACILITY_STATUS} />
                        <BSLAPopupItemComponent label="Facility Cleanup Status" value={atts.FACILITY_CLEANUP_STATUS ?? 'N/A'} />
                        <BSLAPopupItemComponent label="Program" value={atts.VER_PROG} />
                        <BSLAPopupItemComponent label="Cleanup Status Verification Date" value={atts.VER_DATE ? DateTime.fromMillis(atts.VER_DATE).toFormat('MMM dd, yyyy') : 'N/A'} />
                        <BSLAPopupItemComponent label="Cleanup Status Effective Date" value={atts.CLEANUP_STATUS_EFFECTIVE_DATE ? DateTime.fromMillis(atts.CLEANUP_STATUS_EFFECTIVE_DATE).toFormat('MMM dd, yyyy'): 'N/A'} />
                        <div className="mt-3">
                            {atts.ADDRESS1}
                            <br />
                            {atts.CITY}, FL {atts.ZIP5}
                            <br />
                        </div>
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLAPetroleumContaminationLayer;
